module.exports = __webpack_public_path__ + "static/process5-1f1343e4ecad083af4b747b4f039bb94.png";